import { useCallback, useState } from "react";
import type {
  SelectionMenuOwner,
  SidebarSelectionContext,
} from "contexts/DictionaryToolsContext";

// Coordinates the text-selection context menu so only one surface (the page or
// the sidebar) shows it at a time.
export function useSelectionMenu() {
  const [owner, setOwner] = useState<SelectionMenuOwner>(null);

  const update = useCallback((surface: SidebarSelectionContext, isMenuOpen: boolean) => {
    if (isMenuOpen) {
      setOwner(surface);
    } else {
      setOwner(prev => (prev === surface ? null : prev));
    }
  }, []);

  const reset = useCallback(() => setOwner(null), []);

  return { owner, update, reset };
}
